import { ButtonSubmit } from "../ButtonSubmit";
// import { VideoMobile } from "../VideoMobile";
import "./QuestionTwo.scss";

export const QuestionTwo = ({ nextStep }) => {
  const handleSubmit = () => {
    nextStep();
  };
  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <div className="form__global">
        <h3 className="title__global">
          Members of what age are you looking for?
        </h3>
        <div className="olds__wrapper">
          <label className="container-old">
            21-30
            <input className="old" type="checkbox" name="old" />
            <span className="checkmark-old"></span>
          </label>
          <label className="container-old">
            31-37
            <input className="old" type="checkbox" name="old" />
            <span className="checkmark-old"></span>
          </label>
          <label className="container-old">
            38-45
            <input className="old" type="checkbox" name="old" />
            <span className="checkmark-old"></span>
          </label>
          <label className="container-old">
            45 and above
            <input className="old" type="checkbox" name="old" />
            <span className="checkmark-old"></span>
          </label>
        </div>
        <ButtonSubmit
          onClick={handleSubmit}
          className={"button"}
          text={"Continue"}
        />
      </div>
    </div>
  );
};
